export default {"src":"/_next/static/media/404.f5d2bb33.svg","height":375,"width":419,"blurWidth":0,"blurHeight":0};